import { useSettings } from '../slices/settings'
import { withAnimateValue } from './AnimateValue'
import { altitude } from '../utils'

const Altitude = (props) => {
  const { value } = props
  const { unit } = useSettings()
  const [elevation, suffix] = altitude(value, unit)
  if (elevation === undefined) return null
  return `${elevation} ${suffix}`
}

export default withAnimateValue(Altitude, 5)
